<template>
    <div class="header-container">
        <div class="header">
            <img alt="" class="logo_zc" src="../../../assets/img/logo.png"/>
            <div class="home flex align-center">
                <div class="service text-white margin-right-sm">
                    <i class="iconfont icon-kefu margin-right-xs text-xs"></i>客服电话：{{ service_phone }}
                </div>
                <router-link to="/web/admin/card/classify" class="operate" v-if="emofUserTokenSafer">制作名片</router-link>
                <router-link to="/web/login" class="operate" v-else >机构登录</router-link>
                <div  class="operate cursor" @click="dialogFormVisible = true">免费申请</div>
<!--                <a class="to-link margin-left-sm" :href="`${web_zc_home}/tiaoz.html?code=${emofUserTokenSafer}&path=index`" target="_blank">-->
<!--                    <div class="title">返回知诚会首页</div>-->
<!--                    <div class="tips">免费获取更多实用工具</div>-->
<!--                </a>-->
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            :modal-append-to-body="false"
            center
            width="30%">
            <div class="imgs" style="width: 100%;font-size:24px;padding-bottom: 40px;text-align: center;">
                申请试用
            </div>
            <el-form :model="formA" :rules="rules" ref="formA" class="demo-ruleForm">
                <el-form-item label="机构名称：" :label-width="formLabelWidth"  prop="name">
                    <el-input v-model="formA.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系人：" :label-width="formLabelWidth" prop="ren">
                    <el-input v-model="formA.ren" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" required :label-width="formLabelWidth"  prop="tel">
                    <el-input v-model="formA.tel" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="width: 100px;height: 40px;">取 消</el-button>
                <el-button type="primary" @click="shenq" style="width: 100px;height: 40px;margin-left: 40px;">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {service_phone, web_zc_home} from "@/utils/const";
import rules from "@/utils/rules";
import {toast} from "@/utils/utils";

export default {
    components: {},
    name: "HeaderApplyModular",
    data() {

        return {
            service_phone: service_phone,
            web_zc_home: web_zc_home,
            dialogFormVisible:false,
            formLabelWidth: '120px',
            formA: {
                name: '',
                ren: '',
                tel: '',
            },
            rules:{
                name: [
                    { required: true, message: '请输入机构名称', trigger: 'blur' }
                ],
                ren: [
                    { required: true, message: '请输入联系人', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    rules.phone
                ],
            },
        }
    },
    props: {

    },
    computed: {
        emofUserTokenSafer() {
            return this.$store.state.emofUserTokenSafer
        }
    },
    created() {

    },
    methods: {
        //免费申请
        shenq(){
            this.$refs.formA.validate((valid) => {
                var that = this
                if (valid) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('post', 'http://fw.zhichenghui.org.cn/index.php/home/login/organizationApply' );
                    xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
                    xhr.send( 'organizationName=' + this.formA.name +'&contactsPeople='+ this.formA.ren +'&contactsPhone='+this.formA.tel+'&sourceFrom=知诚会-益宣宝');
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4 && xhr.status === 200) {
                            let error = JSON.parse(xhr.responseText);
                            toast(error.msg)
                            that.dialogFormVisible = false
                        }
                    };
                }
            })


        },
    }
}
</script>

<style lang="scss" scoped>
.header-container {
    background-color: #0a2240;
    box-shadow: 0 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo_zc {
            height: 52px;
        }

        .logo {
            margin: 20px 0;
            height: 59px;
            width: 59px;
            border-radius: 59px;
        }

        >.title {
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            margin-left: 20px;
        }

        .home {

            .operate {
                padding: 0 20px;
                height: 40px;
                background-color: var(--orange);
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;
            }
            .operate+.operate {
                margin-left: 20px;
            }

            .to-link {
                width: 150px;
                height: 41px;
                padding: 3px;
                cursor: pointer;
                background-image: linear-gradient(
                        37deg, #ffb400, #fc7802), linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-left: 10px;

                .title {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 17px;
                    color: #fff;
                    text-align: center;
                }

                .tips {
                    font-size: 12px;
                    line-height: 18px;
                    text-align: center;
                    color: #021e3f;
                }
            }
        }

    }
}
</style>